import { c as _c } from "react/compiler-runtime";
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
type ImageDialogProps = {
  /**
   * Container element ID to attach click listeners to
   */
  containerId: string;
  /**
   * Optional className to apply to the image in the dialog
   */
  imageClassName?: string;
};
export function ImageDialog(t0) {
  const $ = _c(14);
  const {
    containerId,
    imageClassName: t1
  } = t0;
  const imageClassName = t1 === undefined ? "max-h-[80vh] max-w-full object-contain" : t1;
  const [selectedImage, setSelectedImage] = useState(null);
  let t2;
  let t3;
  if ($[0] !== containerId) {
    t2 = () => {
      const container = document.getElementById(containerId);
      if (!container) {
        return;
      }
      const handleImageClick = e => {
        e.preventDefault();
        const img = e.target as HTMLImageElement;
        if (img.src) {
          setSelectedImage(img.src);
        }
      };
      const delegatedHandler = e_0 => {
        const target = e_0.target as HTMLElement;
        let currentElement = target;
        while (currentElement && currentElement !== container) {
          if (currentElement.hasAttribute("data-no-image-dialog")) {
            return;
          }
          currentElement = currentElement.parentElement;
        }
        if (target.tagName === "IMG") {
          handleImageClick(e_0);
        }
      };
      container.addEventListener("click", delegatedHandler);
      return () => container.removeEventListener("click", delegatedHandler);
    };
    t3 = [containerId];
    $[0] = containerId;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  const t4 = Boolean(selectedImage);
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setSelectedImage(null);
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <VisuallyHidden asChild={true}><DialogTitle>Image preview</DialogTitle></VisuallyHidden>;
    t7 = <div id="dialog-description" className="sr-only">Full size preview of the selected image</div>;
    $[4] = t6;
    $[5] = t7;
  } else {
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] !== imageClassName || $[7] !== selectedImage) {
    t8 = selectedImage && <img src={selectedImage} alt="Selected preview" className={imageClassName} loading="lazy" decoding="async" />;
    $[6] = imageClassName;
    $[7] = selectedImage;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t8) {
    t9 = <DialogContent className="flex items-center justify-center sm:max-h-[90vh] sm:max-w-[90vw]" aria-describedby="dialog-description">{t6}{t7}{t8}</DialogContent>;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t4 || $[12] !== t9) {
    t10 = <Dialog open={t4} onOpenChange={t5}>{t9}</Dialog>;
    $[11] = t4;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
}